import React from "react";
import { copyTableToClipboard } from "../utils/utils";

const AdminToolBar = ({ title, numberOfItems, filter, setFilter, showModal }) => {

    return (
        <div className="pt-3">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
                <h1 className="h2">{title?.toUpperCase()}</h1>
            </div>

            <div>
                <input className="form-control mb-4" placeholder="Buscar" value={filter} onChange={setFilter} />
            </div>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
                <div>Resultados: {numberOfItems}</div>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="btn-group me-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={copyTableToClipboard}>Copiar</button>
                    </div>
                    {(title !== 'socios' && title !== 'solicitudes') &&
                        <div className="btn-group me-2">
                            <button className="btn btn-sm btn-warning" onClick={showModal}>
                                <i className="fa fa-plus me-2" />
                                Añadir
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )

}

export default AdminToolBar